export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/6c2e077ee9d579bcd865fa9adb9e0787.jpg)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

      <div className="relative z-10 w-full px-12 py-32">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="text-white">
            <div className="inline-flex items-center gap-2 bg-cyan-500/20 backdrop-blur-sm border border-cyan-400/30 px-4 py-2 rounded-full mb-8">
              <i className="ri-shield-check-line text-cyan-400"></i>
              <span className="text-sm font-medium text-cyan-300">Enterprise-Grade Security</span>
            </div>

            <h1 className="text-7xl font-bold leading-tight mb-6">
              Secure Your<br />Digital Freedom
            </h1>

            <p className="text-xl text-gray-300 mb-10 leading-relaxed max-w-xl">
              Military-grade encryption protecting your online privacy across all devices
            </p>

            <div className="flex items-center gap-5">
              <button
                onClick={scrollToContact}
                className="bg-black text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-900 transition-all whitespace-nowrap cursor-pointer"
              >
                Start Free Trial
              </button>
              <button
                onClick={scrollToAbout}
                className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
              >
                Learn More
              </button>
            </div>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative w-full h-[600px]">
              <img
                src="https://readdy.ai/api/search-image?query=3D%20isometric%20illustration%20of%20modern%20devices%20including%20laptop%20smartphone%20and%20tablet%20connected%20through%20glowing%20VPN%20tunnel%20with%20cyan%20and%20purple%20light%20effects%2C%20floating%20security%20icons%20like%20locks%20shields%20and%20encryption%20keys%2C%20professional%20tech%20visualization%20showing%20secure%20network%20connection%20with%20particle%20effects%20and%20gradient%20lighting%2C%20transparent%20background%20suitable%20for%20dark%20hero%20section&width=800&height=800&seq=hero-devices-001&orientation=squarish"
                alt="Secure VPN Connection"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
